import Grid from '@mui/material/Grid';
import '../Components/Styles/categories.css';
import '../Components/Styles/engagements.css';
import '../Components/Styles/accueil.css';
import allImages from '../Components/Assets/allImages';
import allProducts from '../Components/Assets/allProducts';
import { FaTruckFast } from "react-icons/fa6";
import { BiSolidOffer } from "react-icons/bi";
import { MdOutlinePayment } from "react-icons/md";
import { MdArrowOutward } from "react-icons/md";
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Accueil() {
  const [homeData, setHomeData] = useState(null);
  const [homepageProducts, setHomepageProducts] = useState([]);
  const [error, setError] = useState(null);

 useEffect(() => {
  fetch("/api/homepage.php?action=data")
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then(data => setHomeData(data))
    .catch(err => {
      console.error("Erreur /api/homepage :", err);
      setError(err.message);
    });
  }, []);

  useEffect(() => {
    fetch("/api/homepage.php?action=products")
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => setHomepageProducts(data))
      .catch(err => console.error("Erreur /api/homepage_products :", err));
  }, []);
  
  if (error) return <div>Erreur : {error}</div>;
  if (!homeData) return <div>Chargement...</div>;

  const nutripureProducts = homepageProducts.filter(
    p => p.section_name === "nutripure"
  );
  
  const bestsellerProducts = homepageProducts.filter(
    p => p.section_name === "bestseller"
  );
  
  const nouveautesProducts = homepageProducts.filter(
    p => p.section_name === "nouveautes"
  );

  const biotechProducts = homepageProducts.filter(
    p => p.section_name === "biotech"
  );
 
  function HorizontalScroll({ produits, title }) {
    return (
      <section className="horizontal-scroll-section">
        <h2 className="scroll-title">{title}</h2>

        <div className="scroll-container">
          {produits.map(product => (
            <Link
              key={product.id}
              to={`/produit/${product.product_id}`}
              className="scroll-card"
            >
              <img
                src={`/static/media/${product.image}`}
                alt=""
                className="scroll-img"
              />

              <p className="scroll-nom">
                {product.title}
              </p>
            </Link>
          ))}
        </div>
      </section>
    );
}

  
  return <>
  
        <div className="homepage">
          <section className="header-container">
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              {/* Texte à gauche */}
              <Grid item xs={12} md={6} className="header">
                <div className="header-text-left">
                  <h2 className="header-title-left">{homeData?.header_title}</h2>
                  <h2 className="header-reduc">{homeData?.header_subtitle}</h2>
                </div>
              </Grid>

              {/* Image à droite */}
              <Grid item xs={12} md={6} className="header">
                <div className="img-header">
                  <img src={`/static/media/${homeData?.header_image}`} width={600} />
                  <div className="header-text-right">
                    <h2 className="header-title-right">{homeData?.header_title_right}</h2>
                    <h2 className="header_subtitle_right">{homeData?.header_subtitle_right}</h2>
                    {/* <h2 className="header_more_right">{homeData?.header_more_right} <MdArrowOutward /></h2>*/}
                  </div>
                </div>
              </Grid>
            </Grid>
          </section>
          
          {/* NUTRIPURE 
            <section className="gamme-nutripure">
              <div className='nutripure-grid'>
                <div className="div1">
                  <Link to={`/produit/${nutripureProducts[0]?.product_id}`}>
                    <img src={`/static/media/${nutripureProducts[0]?.image}`} alt="" />
                  </Link>
                </div>
                <div className="div2">
                  <img src={allImages.commNutripure} alt="" />
                </div>
                <div className="div3">
                  <Link to={`/produit/${nutripureProducts[1]?.product_id}`}>
                    <img src={`/static/media/${nutripureProducts[1]?.image}`} alt="" />
                  </Link>
                </div>
                <div className="div4">
                  <Link to={`/produit/${nutripureProducts[2]?.product_id}`}>
                    <img src={`/static/media/${nutripureProducts[2]?.image}`} alt="" />
                  </Link>
                </div>
                <div className="div5">
                  <Link to={`/produit/${nutripureProducts[3]?.product_id}`}>
                    <img src={`/static/media/${nutripureProducts[3]?.image}`} alt="" />
                  </Link>
                </div>
                <div className="div6">
                  <div className="info-div6">
                    <h1>{homeData.nutripure_title}</h1>
                  </div>
                </div>
              </div>
            </section> 
            */}
            
            {/* BESTSELLER */}
            <section className='meilleures-ventes'>
              <div className="container-mv-title">
                <div className="mv-container">
                  <h1 className='mv-title'>{homeData?.bestseller_title}</h1>
                  <p className='mv-desc'>{homeData?.bestseller_description}</p>
                </div>
                <div className="mv-infos-container">
                  <p className="mv-infos">FORMULES AVANCÉES</p>
                  <p className="mv-infos">RÉSULTATS CONCRETS</p>
                  <p className="mv-infos">QUALITÉ GARANTIE</p>
                </div>
              </div>
              <div className="img-decouverte">
                {bestsellerProducts.slice(0, 4).map((product, index) => (
                  <div className="mv-cards">
                
                      <div className="mv-card-top">
                        <span className="mv-card-categorie" style={{ '--accent': product.accent_color }}>{product.categorie}</span>
                        <span className="mv-card-number">0{index + 1}</span>
                      </div>
                
                      <h3 className="mv-card-nom">{product.title}</h3>
                      <p className="mv-card-desc">{product.subtitle}</p>
                
                      <Link to={`/produit/${product.product_id}`} key={product.id}>
                        <div className="mv-card-img-wrap">
                          <img src={`/static/media/${product.image}`} alt={product.nom} />
                        </div>
                
                        <div className="mv-card-voir">↗ Voir</div>
                      </Link>
                
                    </div>
                ))}
              </div>
          </section>

          {/* Points forts */}
          <section>
              <div className="pf-container">
                <div className="points-forts">
                  <FaTruckFast size={40}/>
                  <div className="pf-title">Livraison Express</div>
                  <div className="pf-desc">Dans le Nord-Pas-de-Calais</div>
                </div>
                <div className="points-forts">
                  <BiSolidOffer size={40}/>
                  <div className="pf-title">Livraison Offerte</div>
                  <div className="pf-desc">A partir de 40€ d'achat</div>
                </div>
                <div className="points-forts">
                  <MdOutlinePayment size={40}/>
                  <div className="pf-title">Paiement sécurisé</div>
                  <div className="pf-desc">Régler votre commande par CB en toute sécurité</div>
                </div>
              </div>
          </section>

          {/* BIOTECH */}
            <section className='gamme-biotech'>
              <p className="biotech-eyebrow">{homeData?.biotech_eyebrow}</p>
              <h2 className="biotech-title">{homeData?.biotech_title}</h2>
              <p className="biotech-subtitle">{homeData?.biotech_subtitle}</p>

              <div className="biotech-grid">
                {biotechProducts.slice(0, 4).map((product) => (
                  <Link
                    key={product.id}
                    to={`/produit/${product.product_id}`}
                    className="biotech-card"
                    style={{ '--accent': product.accent_color || '#7B5EEA' }}
                  >
                    {product.bg_image && (
                      <img className="biotech-card-bg" src={`/static/media/${product.bg_image}`} alt="" aria-hidden="true" />
                    )}
                    <div className="biotech-card-overlay" />
                  
                    <div className="biotech-card-content">
                      <h3 className="biotech-card-title">{product.title}</h3>
                      <p className="biotech-card-desc">{product.subtitle}</p>
                      <span className="biotech-card-cta">↗</span>
                    </div>
                  
                    {product.image && (
                      <img className="biotech-card-product" src={`/static/media/${product.image}`} alt={product.title} />
                    )}
                  </Link>
                ))}
              </div>
            </section>
            
          <section className="nouveautes-section">
            <div className="nouveautes-container">
              <h1 className="nouveautes-title">
                {homeData?.nouveautes_title}
              </h1>

              <div className="nouveautes-grid">
                {/* Texte côté gauche */}
                <div className="nouveautes-texts">
                  <div className="nouveautes-card">
                    <h2 className="nouveautes-subtitle">
                      {homeData?.nouveautes_subtitle}
                    </h2>
                    <p className="nouveautes-desc">
                      {homeData?.nouveautes_description}
                    </p>
                  </div>

                  <div className="nouveautes-card nouveautes-card--highlight">
                    <h2 className="nouveautes-subtitle">
                      {homeData?.promo_title}
                    </h2>
                    <p className="nouveautes-desc">
                      {homeData?.promo_description}
                    </p>
                    <Link to="/promo" className="btn-promo">
                      {homeData?.promo_button}
                    </Link>
                  </div>
                </div>

                {/* Images côté droit */}
                <div className="nouveautes-images">
                  <Link to={`/produit/${nouveautesProducts[0]?.product_id}`}>
                    <img src={`/static/media/${nouveautesProducts[0]?.image}`} alt="" />
                  </Link>
                  <Link to={`/produit/${nouveautesProducts[1]?.product_id}`}>
                    <img src={`/static/media/${nouveautesProducts[1]?.image}`} alt="" />
                  </Link>
                  <Link to={`/produit/${nouveautesProducts[2]?.product_id}`}>
                    <img src={`/static/media/${nouveautesProducts[2]?.image}`} alt="" />
                  </Link>
                  <Link to="/categorie/rasage" className="rasage-card">
                    <h2>Découvrez notre gamme pour le rasage</h2>
                    <p>Soins, accessoires et indispensables pour un rasage parfait.</p>
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/*<div className="mobile-homepage">
          
          <div className="mobile-nutripure-container">
            <div className="mob-nutripure-imgs">
              <HorizontalScroll produits={nutripureProducts} title="Découvrez notre gamme Nutripure" />
            </div>
          </div>

          <div className="banner-mobile"></div>

          <div className="mobile-nutripure-container bestseller-tablette">
            <div className="mob-nutripure-imgs">
              <HorizontalScroll produits={bestsellerProducts} title="Nos meilleures ventes" />
            </div>
          </div>

          <section>
              <div className="pf-container">
                <div className="points-forts">
                  <FaTruckFast size={40}/>
                  <div className="pf-title">Livraison Express</div>
                  <div className="pf-desc">Dans le Nord-Pas-de-Calais</div>
                </div>
                <div className="points-forts">
                  <BiSolidOffer size={40}/>
                  <div className="pf-title">Livraison Offerte</div>
                  <div className="pf-desc">A partir de 80€ d'achat</div>
                </div>
                <div className="points-forts">
                  <MdOutlinePayment size={40}/>
                  <div className="pf-title">Paiement sécurisé</div>
                  <div className="pf-desc">Régler votre commande par CB en toute sécurité</div>
                </div>
              </div>
          </section>
      
          <div className="mobile-nutripure-container nouveautes-tablette">
            <div className="mob-nutripure-imgs">
              <HorizontalScroll produits={nouveautesProducts} title="Nos nouveautés" />
            </div>
          </div>

        </div>*/}


      </>  
    
    
    
  
}

export default Accueil